module.exports = __webpack_public_path__ + "static/media/pages.67189a00.svg";